module.exports = __webpack_public_path__ + "img/signet_gold.7befaa01.gif";